module.exports = __webpack_public_path__ + "static/media/icons.ef1fa95d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons.eot
// module id = 2533
// module chunks = 7